import { useQuery } from 'react-query';
import { EmailTemplateService } from '../../services/EmailTemplateService';

export const useCalendarEventTemplates = () => {
  return useQuery({
    queryKey: ['calendar_event_templates'],
    queryFn: async () => await EmailTemplateService.listCalendarInvites(),
  });
};
